// test999
(999 && 0);
